import React from 'react';

interface HourGlassProps {
  color?: string;
  size?: number | string;
}
const HourGlass = ({ color = '#343330', size = 20 }: HourGlassProps) => {
  return (
    <svg
      width={`${size}`}
      height={`${size}`}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3976 24.57L17.4463 16L26.3976 7.43C26.4026 7.42427 26.4081 7.41885 26.4138 7.41375C26.6933 7.13405 26.8837 6.77777 26.9607 6.38993C27.0378 6.00209 26.9982 5.6001 26.8469 5.23476C26.6956 4.86942 26.4394 4.55713 26.1107 4.33736C25.782 4.11758 25.3955 4.00018 25.0001 4H7.00005C6.60462 4.00018 6.21812 4.11758 5.8894 4.33736C5.56067 4.55713 5.30447 4.86942 5.15317 5.23476C5.00187 5.6001 4.96226 6.00209 5.03936 6.38993C5.11645 6.77777 5.30678 7.13405 5.5863 7.41375C5.59203 7.41885 5.59745 7.42427 5.60255 7.43L14.5538 16L5.60255 24.57C5.59745 24.5757 5.59203 24.5812 5.5863 24.5863C5.30678 24.866 5.11645 25.2222 5.03936 25.6101C4.96226 25.9979 5.00187 26.3999 5.15317 26.7652C5.30447 27.1306 5.56067 27.4429 5.8894 27.6626C6.21812 27.8824 6.60462 27.9998 7.00005 28H25.0001C25.3956 28.0001 25.7823 27.8828 26.1112 27.6632C26.4401 27.4435 26.6965 27.1312 26.8479 26.7658C26.9994 26.4004 27.0391 25.9983 26.9621 25.6104C26.885 25.2224 26.6946 24.866 26.4151 24.5863C26.4089 24.5812 26.4031 24.5758 26.3976 24.57ZM25.0001 6L22.9126 8H9.09005L7.00005 6H25.0001ZM7.00005 26L16.0001 17.385L25.0001 26H7.00005Z"
        fill={color}
      />
    </svg>
  );
};

export default HourGlass;
